<template>
        <header :class="{scrolled: scrolled}">
          <div class="hbg"><div class="container"></div></div>
          <div class="container">
            <h1 class="logo"><router-link :to="{name: 'home'}">Krnny Pilates</router-link></h1>
            <div class="filter">
              <a href="" class="mhandle" v-on:click.prevent="$emit('toggleMenu')"><span></span></a>
              <slot />
            </div>
            <div class="tools">
              <div class="subsc" v-if="true || !isAdminPart">
                <router-link :to="{name: 'packages'}" class="subsctoggle" :class="{active: $route.name=='packages'}">
                  Subscriptions
                </router-link>
              </div>
              <div class="cart" :class="{open: cartOpen}">
                <a href="" class="stoggle" v-on:click.prevent="cartOpen=!cartOpen">
                  <span v-if="cart.cartItems && cart.cartItems.length">{{ cart.cartItems.length }}</span>
                </a>
                <cart />
              </div>
              <div class="search" :class="{open: searchOpen}">
                <a href="" class="stoggle" v-on:click.prevent="searchOpen=!searchOpen"></a>
                <form>
                  <input ref="searchfield" type="text" placeholder="Search here..." />
                  <button>Search</button>
                </form>
              </div>
              <div class="user-control" v-if="!loggedIn" :class="{open:isuseropen}">
                <a href="" class="mob-user-handle" v-on:click.prevent="isuseropen=!isuseropen"></a>
                <router-link :to="{name: 'user.register'}" v-on:click.native="isuseropen=false">Register</router-link>
                <router-link :to="{name: 'user.login'}" v-on:click.native="isuseropen=false">Login</router-link>
              </div>
              <div class="user-control" v-else :class="{open:isuseropen}">
                <a href="" class="mob-user-handle" v-on:click.prevent="isuseropen=!isuseropen"></a>
                <router-link :to="{name: 'admin.videos'}" v-if="loggedIn.admin" v-on:click.native="isuseropen=false">Admin</router-link>
                <a href="" v-on:click.prevent="doLogout(); isuseropen=false">Logout</a>
              </div>
            </div>  
          </div>
        </header>
</template>
<script>
export default {
  data: ()=>({
    searchOpen: false,
    cartOpen: false,
    scrolled: false,
    cart: {},
    isuseropen: false,
  }),
  computed: {
    isAdminPart() {
      return this.$route.name.startsWith('admin') ||
             this.$route.name=='content.postedit';
    },
    loggedIn() {
      return appRoot.loggedIn;
    },
  },
  watch: {
    searchOpen() {
      if (this.searchOpen)
        this.$refs.searchfield.focus();
    },
  },
  methods: {
    async doLogout() {
      await api.logout();
      this.$router.push({name: "home"});
    },
  },
  mounted() {
    var $window=$(window);
    $window.on("scroll.header", (e)=>{
      this.scrolled=$window.scrollTop()>20;
    }).trigger("scroll.header");
  },
  destroyed() {
    $(window).off("scroll.header");
  },
  created() {
    window.appHeadNav=this;
    this.$nextTick(()=>{
      this.cart=window.appCart;
    });
  },
}
</script>
